import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BidQuoteModel } from "../../interfaces";

@Component({
    selector: "bid-quotes",
    templateUrl: "./bidQuotes.tmpl.html",
    styleUrls: [
        "./bidQuotes.component.scss"
    ],
    standalone: false
})
export class BidQuotesComponent
{
    @Output() readonly delete = new EventEmitter<BidQuoteModel>();
    @Output() readonly viewAttachments = new EventEmitter<BidQuoteModel>();
    @Output() readonly viewNotes = new EventEmitter<BidQuoteModel>();

    @Input() canEdit: boolean;
    @Input() model: BidQuoteModel[];

    get bidQuotes(): BidQuoteModel[] { return this.model; }
    get hasBidQuotes(): boolean { return this.bidQuotes?.length > 0; }

    onDelete(selected: BidQuoteModel): void
    {
        this.delete.emit(selected);
    }

    showAttachments(selected: BidQuoteModel): void
    {
        this.viewAttachments.emit(selected);
    }

    showNotes(selected: BidQuoteModel): void
    {
        this.viewNotes.emit(selected);
    }
}
